import { useEffect, useState } from 'react'
import { scrollToTop } from 'utils/utils'
import { DynamicQuestionsSteps } from './types'

export const useActiveStep = (requiredSteps: DynamicQuestionsSteps, requiredStepKeys: string[]) => {
  const [activeStepKey, setActiveStepKey] = useState<string>()
  const [isLoadingActiveStep, setIsLoadingActiveStep] = useState(true)

  const getFirstPendingStepKey = () => {
    return requiredStepKeys?.find(stepKey =>
      Object.values(requiredSteps?.[stepKey])?.some(({ savedAnswer }) => !savedAnswer)
    )
  }

  const loadInitialActiveStep = () => {
    const firstPendingStepKey = getFirstPendingStepKey()
    const lastStepKey = requiredStepKeys.at(-1)
    const initialActiveStep = firstPendingStepKey ?? lastStepKey
    initialActiveStep !== activeStepKey && setActiveStepKey(initialActiveStep)
    setIsLoadingActiveStep(false)
  }

  const goToNextStep = () => {
    const currentStepIndex = requiredStepKeys?.indexOf(activeStepKey)
    const nextStepKey = requiredStepKeys?.[currentStepIndex + 1]
    nextStepKey && setActiveStepKey(nextStepKey)
  }

  const onBack = (stepKey: string) => setActiveStepKey(stepKey)

  useEffect(() => {
    !!requiredSteps && isLoadingActiveStep && loadInitialActiveStep()
  }, [requiredSteps, isLoadingActiveStep])

  useEffect(() => scrollToTop(), [activeStepKey])

  return {
    activeStepKey,
    isLoadingActiveStep,
    goToNextStep,
    onBack,
  }
}
